<template>
    <div class="full">
        <div class="login-form ubuntu-font" v-if="!forgetPage">
            <!-- LOGIN PAGE -->
            <h1 class="login-title">LOGIN</h1>

            <form @keydown="form.onKeydown($event)" @submit.prevent="doLogin">
                <b-field :message="form.errors.get('username')" :type="{ 'is-danger': form.errors.has('username') }" label="Username">
                    <b-input
                        ref="usernameinput"
                        maxlength="240"
                        placeholder="username"
                        required
                        type="text"
                        v-model="form.username"
                        size="is-medium"
                    ></b-input>
                </b-field>
                <b-field :message="form.errors.get('password')" :type="{ 'is-danger': form.errors.has('password') }" label="Password">
                    <b-input maxlength="240" placeholder="Password" required type="password" size="is-medium" v-model="form.password"></b-input>
                </b-field>

                <a style="float: right" @click="forgetPage = !forgetPage">Forget?</a>
                <b-checkbox value="true" disabled> Remember me </b-checkbox>
                <br />
                <br />
                <b-button
                    :loading="isLoading"
                    size="is-medium"
                    type="is-primary"
                    native-type="submit"
                    expanded
                    @click="doLogin"
                    :disabled="isLoading"
                >
                    Login
                </b-button>
            </form>
        </div>
        <div class="login-form ubuntu-font" v-else>
            <!-- FORGET PASSWORD PAGE -->
            <h1 class="login-title">Forget Password</h1>
            <b-field>
                <b-input placeholder="Email" size="is-medium"></b-input>
            </b-field>
            <br />
            <div class="field has-addons">
                <p class="control">
                    <b-button outlined inverted type="is-light" @click="forgetPage = false">Cancel</b-button>
                </p>
                <p class="control w-100">
                    <b-button expanded type="is-primary">Submit</b-button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import vform from "vform";

export default {
    data() {
        return {
            form: new vform({
                username: "",
                password: "",
            }),
            isLoading: false,
            forgetPage: false,
        };
    },
    methods: {
        doLogin() {
            this.isLoading = true;
            this.form
                .post("/login")
                .then(async ({ data }) => {
                    this.$store.dispatch("setToken", data.token);
                    this.$localStorage.set("token", data.token);
                    setTimeout(() => {
                        this.$router.replace("/home");
                    }, 400);
                    await this.$store.dispatch("loadAPI", this.$axios);
                })
                .finally(() => (this.isLoading = false));
        },
    },
    mounted() {
        if (this.$route.query.logout === null) {
            this.$localStorage.remove("token");
            this.$store.dispatch("setToken", null);
            // window.location.href = "/";
        }
        if (this.$localStorage.get("token")) {
            this.$router.replace("/home");
        } else {
            this.$refs.usernameinput.focus();
        }
    },
};
</script>

<style>
#app {
    height: 100%;
}
.full {
    height: 100%;
    min-height: 100%;
    display: grid;
}
.login-form {
    margin: auto;
    width: 330px;
}
.login-title {
    font-size: 30px;
    text-align: center;
    margin-bottom: 2rem;
}
.ubuntu-font * {
    font-weight: bold;
    font-family: Ubuntu;
}
</style>